<template>
  <div v-if="Object.keys(dependencies).length">
    <table class="table table-striped table-borderless beast-table">
      <thead>
      <tr>
        <th class="beast-table-pkgName">Package Name</th>
        <th class="beast-table-pkgVersion">Package Version</th>
      </tr>
      </thead>
      <tbody>
      <tr v-bind:key="packageName"
          v-for="(packageVersion, packageName) in dependencies">
        <td class="beast-table-pkgName">
          <router-link :to="`/package/${packageName}`">{{packageName}}</router-link>
        </td>
        <td class="beast-table-pkgVersion" v-text="packageVersion"></td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    This package doesn't depend on anything!
  </div>
</template>

<style scoped lang="scss">
  .beast-table {
    .beast-table-pkgName {
      width: 75%;
      a {
        color: $beast-dark-gray;
      }
    }
    .beast-table-pkgVersion {
      width: 25%;
      text-align: center;
    }
  }
</style>

<script>
export default {
  props: {
    pkg: Object,
    versionName: String
  },
  computed: {
    url() {
      return !this.versionName
        ? `/packages/${this.pkg.name}`
        : `/packages/${this.pkg.name}/${this.versionName}`;
    },
  },
  watch: {
    async pkg() {
      await this.readData();
    }
  },
  data() {
    return {
      dependencies: {}
    };
  },
  methods: {
    async readData() {
      const response = await this.axios.get(`${this.url}/dependencies`);
      this.dependencies = response.data;
    }
  },
  async beforeMount() {
    if (this.pkg.name !== "") {
      await this.readData();
    }
  }
};
</script>
